import { render } from "./RelationBrowser.vue?vue&type=template&id=3e163183&scoped=true&ts=true"
import script from "./RelationBrowser.vue?vue&type=script&lang=ts"
export * from "./RelationBrowser.vue?vue&type=script&lang=ts"

import "./RelationBrowser.vue?vue&type=style&index=0&id=3e163183&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e163183"]])

export default __exports__